import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Home, ExternalLink } from 'lucide-react';
import DemoVisualization from '../components/demo/DemoVisualization';
import { Line } from 'react-chartjs-2';

export default function DemoPage() {
  const chartData = {
    labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    datasets: [{
      label: 'Revenue Trend',
      data: [10000, 12000, 15000, 18000, 20000, 22000, 25000, 28000, 30000, 32000, 35000, 38000],
      backgroundColor: 'rgba(255, 99, 132, 0.2)',
      borderColor: 'rgba(255, 99, 132, 1)',
      borderWidth: 1
    }]
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Navigation */}
      <div className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
              <Link 
                to="/dashboard" 
                className="flex items-center gap-2 text-gray-600 hover:text-blue-600 transition-colors"
              >
                <ArrowLeft className="w-4 h-4" />
                Back to Dashboard
              </Link>
              <div className="h-4 w-px bg-gray-300"></div>
              <div className="flex items-center gap-2 text-sm text-gray-500">
                <Home className="w-4 h-4" />
                <span>/</span>
                <span className="text-gray-900 font-medium">Analytics Demo</span>
              </div>
            </div>
            
            <div className="flex items-center gap-3">
              <span className="text-sm text-gray-500">
                Demonstration Mode
              </span>
              <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
            </div>
          </div>
        </div>
      </div>

      {/* Demo Content */}
      <DemoVisualization 
        showPerformanceDashboard={true}
        showCompetitorMapping={true}
      />

      {/* Call to Action */}
      <div className="bg-white border-t">
        <div className="max-w-4xl mx-auto px-6 py-12 text-center">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">
            Ready to Analyze Your Gas Station?
          </h2>
          <p className="text-gray-600 mb-8 max-w-2xl mx-auto">
            Get started with a comprehensive valuation and competitive analysis of your property. 
            Our AI-powered platform provides actionable insights to maximize your station's performance.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/valuation"
              className="inline-flex items-center px-6 py-3 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition-colors"
            >
              Start Valuation
              <ExternalLink className="w-4 h-4 ml-2" />
            </Link>
            <Link
              to="/dashboard"
              className="inline-flex items-center px-6 py-3 border border-gray-300 text-gray-700 font-medium rounded-lg hover:bg-gray-50 transition-colors"
            >
              View Dashboard
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
